import React, { useState } from "react";
import { Modal, Button, LoadingOverlay } from "@mantine/core";
import { countryListLocal } from "./CountryList";
import { useLocation } from "react-router-dom";
function BookingModal({ ProductDetail }) {
    // console.log(ProductDetail)
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const location = useLocation();
    const countrylist = countryListLocal.item.sort((a, b) => a.name.common.localeCompare(b.name.common));
    const [formData, setFormData] = useState({
        fname: "",
        email: "",
        gender: "Male",
        country: "",
        city: "",
        phone: "",
        address: "",
    });
    const [errors, setErrors] = useState({});

    const OpenCloseModal = () => {
        setOpenModal(!openModal);
        setSuccessMessage('');
        setErrorMessage('');
        setErrors({});
    };

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Validation
    const validateForm = () => {
        let newErrors = {};

        if (!formData.fname.trim()) newErrors.fname = "Full name is required";
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid";
        }
        if (!formData.gender) newErrors.gender = "Gender is required";
        if (!formData.country) newErrors.country = "Country is required";
        if (!formData.city.trim()) newErrors.city = "City is required";
        if (!formData.phone) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\d{7,15}$/.test(formData.phone)) {
            newErrors.phone = "Phone number must be 7–15 digits";
        }
        if (!formData.address.trim()) newErrors.address = "Address is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const category = location.pathname.split('/');
            setLoading(true)
            // const bookingData = {
            //     category_id: ProductDetail?.category?.category_id,
            //     product_id: ProductDetail?.logo_id,
            //     varient_id: ProductDetail?.id,
            //     category_name: category[1],
            //     product_name: ProductDetail?.category?.title,
            //     varient_name: ProductDetail?.title,
            //     full_name: formData.fname,
            //     email: formData.email,
            //     gender: formData.gender,
            //     country: formData.country,
            //     city: formData.city,
            //     phone_number: formData.phone,
            //     address: formData.address
            // };
            const formDataObj = new FormData();
            formDataObj.append('category_id', ProductDetail?.categorys ? ProductDetail?.categorys?.category_id : category[1] === 'e-bikes' ? ProductDetail?.bike_product?.category?.category_id : ProductDetail?.category?.category_id ? ProductDetail?.category?.category_id : ProductDetail?.category?.id);
            formDataObj.append('product_id', ProductDetail?.logo_product_id ? ProductDetail?.category?.id : ProductDetail?.bike_specification ? ProductDetail?.bike_specification?.bike_product_id : ProductDetail?.id);
            formDataObj.append('varient_id', ProductDetail?.logo_product_id ? ProductDetail?.id :ProductDetail?.variant && ProductDetail?.variant !== null ? ProductDetail?.variant?.id :'');
            formDataObj.append('category_name', category[1]);
            formDataObj.append('product_name', category[1] === 'e-bikes' ?  ProductDetail?.bike_product?.title  :ProductDetail?.title);
            formDataObj.append('varient_name', '');
            formDataObj.append('full_name', formData.fname);
            formDataObj.append('email', formData.email);
            formDataObj.append('gender', formData.gender);
            formDataObj.append('country', formData.country);
            formDataObj.append('city', formData.city);
            formDataObj.append('phone_number', formData.phone);
            formDataObj.append('address', formData.address);

            try {
                const response = await fetch("https://admin.energybazzar.com/api/bookings", {
                    method: "POST",
                    body: formDataObj,
                });
                const result = await response.json();
                setLoading(false)
                if (result.status === true) {
                    setSuccessMessage(result.message);
                    setFormData({
                        fname: "",
                        email: "",
                        gender: "Male",
                        country: "",
                        city: "",
                        phone: "",
                        address: "",
                    });
                    // setOpenModal(false);


                } else {
                    setErrorMessage(result.message)
                }
            } catch (error) {
                setLoading(false)
                console.error("Error submitting form:", error);
                setErrorMessage('Error submitting form please try later.')
            }

        }
    };

    return (
        <div>
            <Modal
                opened={openModal}
                onClose={OpenCloseModal}
                title="Customer Detail"
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
                size="lg"
            >
                <LoadingOverlay visible={loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 1 }} />
                {/* Bootstrap Form */}
                <form onSubmit={handleSubmit}>
                    <div className="row p-3">
                        {/* Full Name */}
                        <div className="mb-2 col-md-12">
                            <label className="form-label">Full Name</label>
                            <input
                                type="text"
                                className={`form-control ${errors.fname ? "is-invalid" : ""}`}
                                name="fname"
                                value={formData.fname}
                                onChange={handleChange}
                            />
                            {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                        </div>

                        {/* Email */}
                        <div className="mb-2 col-md-6 col-12 col-sm-12">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>

                        {/* Gender */}
                        <div className="mb-2 col-md-6 col-12 col-sm-12">
                            <label className="form-label">Gender</label>
                            <div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="gender"
                                        value="Male"
                                        checked={formData.gender === "Male"}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label">Male</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="gender"
                                        value="Female"
                                        checked={formData.gender === "Female"}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label">Female</label>
                                </div>
                            </div>
                            {errors.gender && <div className="text-danger small">{errors.gender}</div>}
                        </div>

                        {/* Country */}
                        <div className="mb-2 col-md-6 col-12 col-sm-12">
                            <label className="form-label">Country</label>
                            <select
                                className={`form-select ${errors.country ? "is-invalid" : ""}`}
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                            >
                                <option value="">Select Country</option>
                                {countrylist.map((item, index) => (
                                    <option key={index} value={item.name.common}>{item.name.common}</option>
                                ))}
                            </select>
                            {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                        </div>

                        {/* City */}
                        <div className="mb-2 col-md-6 col-12 col-sm-12">
                            <label className="form-label">City</label>
                            <input
                                type="text"
                                className={`form-control ${errors.city ? "is-invalid" : ""}`}
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                            />
                            {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                        </div>

                        {/* Phone */}
                        <div className="mb-2  col-md-12">
                            <label className="form-label">Phone Number</label>
                            <input
                                type="tel"
                                className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                            />
                            {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                        </div>

                        {/* Address */}
                        <div className="mb-2  col-md-12">
                            <label className="form-label">Address</label>
                            <textarea
                                className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                name="address"
                                rows="2"
                                value={formData.address}
                                onChange={handleChange}
                            ></textarea>
                            {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                        </div>
                        {errorMessage && (
                            <div class="alert alert-danger my-2" role="alert">
                                {errorMessage}
                            </div>
                        )}
                        {successMessage && (
                            <div class="alert alert-success my-2" role="alert">
                                {successMessage}
                            </div>
                        )}
                        <Button type="submit" className="btn btn-primary w-100">
                            Submit
                        </Button>
                    </div>
                </form>
            </Modal>

            <Button className="btn btn-primary" onClick={OpenCloseModal}>
                Book Now
            </Button>
        </div>
    );
}

export default BookingModal;
